import { filter, findIndex, includes, sortBy } from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { scroller } from 'react-scroll';
import { message } from 'antd';
import TagManagementTrendKeywordWrap from '../../views/tag/management/trendKeyword/TagManagementTrendKeywordWrap';
import { appActions } from '../../store/modules/app';
import { tagActions } from '../../store/modules/tag';
import { _LIST_PAGINATION_MODEL } from '../../store/modules/app/models';
import { TAG_LINK_LIST_FILTER_OPTION_MODEL, TAG_LINK_LIST_SORT_OPTION_MODEL } from '../../store/modules/tag/models';
import { NO_DATA_ON_EXCEL_DOWNLOAD_WARNING_TEXT } from '../../constants/service/common/utilConstants';
import {
  TAG_TREND_KEYWORD_ITEM_COUNT,
  TAG_TREND_KEYWORD_MANAGEMENT_PAGE_PANEL_NAME,
  TAG_TREND_KEYWORD_SECTION_TYPE,
} from '../../constants/service/app/tagConstants';
import { asyncSimpleModal } from '../../lib/common';

class TagTendKeywordManagementContainer extends Component {
  componentDidMount() {
    this.initiate();
  }

  /**
   *  초기 데이터 불러오기
   */
  initiate = () => {
    const { getTagTrendKeywordData } = this.props;

    /**
     *  태그 리스트의 필터, 정렬, 방식이 같으므로
     *  처음요청을 할 때는 하나의 검색 옵션으로 요청을 함
     */
    getTagTrendKeywordData({
      option: {
        filterOption: TAG_LINK_LIST_FILTER_OPTION_MODEL,
        sortOption: TAG_LINK_LIST_SORT_OPTION_MODEL,
        pagination: _LIST_PAGINATION_MODEL,
      },
    });
  };

  /**
   *  태그 트렌드 키워드 편집 하기
   */
  onSubmit = (tagTrendKeywordSectionType) => {
    const { tagTrendKeyword, toggleModal } = this.props;

    /**
     *  태그 트렌드 키워드 컨텐츠 최소 개수 체크
     */
    const targetTagTrendKeywordContentsIdList = tagTrendKeyword[tagTrendKeywordSectionType].selectedItemList.idList;

    /**
     *  top 30 추천 태그 최소 개수 체크
     */
    const minimumNumberOfTargetTagTrendKeywordContentsCount =
      TAG_TREND_KEYWORD_ITEM_COUNT[tagTrendKeywordSectionType].MINIMUM_NUMBER_OF_ITEM_COUNT;
    if (targetTagTrendKeywordContentsIdList.length < minimumNumberOfTargetTagTrendKeywordContentsCount) {
      message.error(`top 30 추천 태그는 최소 ${minimumNumberOfTargetTagTrendKeywordContentsCount}개 이상입니다.`);
      scroller.scrollTo(TAG_TREND_KEYWORD_MANAGEMENT_PAGE_PANEL_NAME[tagTrendKeywordSectionType]);
      return;
    }

    /**
     *  태그 트렌드 키워드 리스트에 대한 메모를 입력 후
     *  태그 탭 메인 컨텐트를 저장할 수 있도록 함.
     */
    toggleModal({
      name: 'editTrendKeywordModal',
      data: {
        tagTrendKeywordSectionType,
        targetTagTrendKeywordContentsIdList,
      },
      value: true,
    });
  };

  /**
   *  태그 트렌드 키워드 컨텐츠 리스트 불러오기
   */
  getTagTrendKeywordContentsList = (option) => {
    const { getTagTrendKeywordContentsList, tagTrendKeyword } = this.props;
    const { tagTrendKeywordSectionType } = option;
    const { filterOption, sortOption, pagination } = tagTrendKeyword[tagTrendKeywordSectionType].itemList;

    getTagTrendKeywordContentsList({
      tagTrendKeywordSectionType,
      filterOption,
      sortOption,
      pagination,
      ...option,
    });
  };

  /**
   *  태그 트렌드 키워드 컨텐츠 리스트 선택하기
   */
  selectTrendKeywordMainContentsList = async (action, moveIdList, tagTrendKeywordSectionType) => {
    const { setData, tagTrendKeyword } = this.props;
    const { itemList, selectedItemList } = tagTrendKeyword[tagTrendKeywordSectionType];

    /**
     *  업데이트 될 선택된 태그 트렌드 키워드 컨텐츠 리스트
     */
    let updatedSelectTagTrendKeywordContentsList = [];

    /**
     *  태그 탭 메인 컨텐츠 리스트 추가
     */
    if (action === 'add') {
      let targetList = filter(itemList.list, (item) => includes(moveIdList, item.id));

      /**
       *  이전에 선택되어 있던 아이템 리스트와
       *  추가로 선택된 태그 아이템을 합침
       */
      updatedSelectTagTrendKeywordContentsList = [...targetList, ...selectedItemList.list];

      /**
       *  추가하려고 하는 트렌드 키워드 리스트 개수가 초과되었을 경우
       */
      if (TAG_TREND_KEYWORD_ITEM_COUNT[tagTrendKeywordSectionType].MAXIMUM_NUMBER_OF_ITEM_COUNT) {
        if (
          updatedSelectTagTrendKeywordContentsList.length >
          TAG_TREND_KEYWORD_ITEM_COUNT[tagTrendKeywordSectionType].MAXIMUM_NUMBER_OF_ITEM_COUNT
        ) {
          await asyncSimpleModal({
            type: 'error',
            title: '선택된 아이템 개수 초과',
            message: `해당 아이템 개수는 최대 ${TAG_TREND_KEYWORD_ITEM_COUNT[tagTrendKeywordSectionType].MAXIMUM_NUMBER_OF_ITEM_COUNT} 입니다.`,
          });
          return;
        }
      }
    } else if (action === 'remove') {
      /**
       *  태그 탭 메인 컨텐츠 리스트 해제
       */
      /**
       *  이전에 선택되어 있던 아이템 리스트에서
       *  해제한 아이템을 빼버림
       */
      updatedSelectTagTrendKeywordContentsList = filter(
        selectedItemList.list,
        (item) => !includes(moveIdList, item.id),
      );
    }

    /**
     *  선택되어진 선택된 아이템은
     *  선택할 수 없도록 함
     */
    const updatedTagTrendKeywordContentsList = itemList.list.map((item) => ({
      ...item,
      uncheckable: includes(moveIdList, item.id) ? action === 'add' : item.uncheckable,
    }));
    setData({
      path: ['tagTrendKeyword', tagTrendKeywordSectionType, 'itemList', 'list'],
      value: updatedTagTrendKeywordContentsList,
    });

    /**
     *  선택된 아이템 업데이트하기
     */
    setData({
      path: ['tagTrendKeyword', tagTrendKeywordSectionType, 'selectedItemList'],
      value: {
        list: updatedSelectTagTrendKeywordContentsList,
        idList: updatedSelectTagTrendKeywordContentsList.map((item) => item.id),
      },
    });
  };

  /**
   * 태그 트렌드 키워드 컨텐츠리스트 순서 변경하기
   */
  onDragEndSelectTagTrendKeywordContentsList = async (newList, tagTrendKeywordSectionType) => {
    const { setData, tagTrendKeyword } = this.props;
    const { selectedItemList } = tagTrendKeyword[tagTrendKeywordSectionType];

    const updatedSelectTagTrendKeywordContentsList = sortBy(selectedItemList.list, (item) =>
      findIndex(newList, (_item) => _item.id === item.id),
    );

    await setData({
      path: ['tagTrendKeyword', tagTrendKeywordSectionType, 'selectedItemList'],
      value: {
        list: updatedSelectTagTrendKeywordContentsList,
        idList: updatedSelectTagTrendKeywordContentsList.map((item) => item.id),
      },
    });
  };

  /**
   *  태그 트렌드 키워드 미리보기
   */
  tagTrendKeywordPreview = () => {
    const { getTagTrendKeywordPreviewData, tagTrendKeyword } = this.props;

    getTagTrendKeywordPreviewData({
      /**
       *  선택된 top 30 추천 태그 리스트의 태그 id 리스트
       */
      tagTopRankTagIdList:
        tagTrendKeyword[TAG_TREND_KEYWORD_SECTION_TYPE.RECOMMEND_TAG_TOP_RANK_LIST].selectedItemList.idList,
      /**
       *  선택된 스타일별 추천 태그 리스트의 태그 id 리스트
       */
      tagStyleTagIdList:
        tagTrendKeyword[TAG_TREND_KEYWORD_SECTION_TYPE.RECOMMEND_TAG_STYLE_LIST].selectedItemList.idList,
      /**
       *  선택된 태그 모아보기 추천 태그 리스트의 태그 id 리스트
       */
      tagCollectionTagIdList:
        tagTrendKeyword[TAG_TREND_KEYWORD_SECTION_TYPE.RECOMMEND_TAG_COLLECTION_LIST].selectedItemList.idList,
    });
  };

  /**
   *  전체 태그 리스트 엑셀 다운로드
   */
  getTagTrendKeywordAllListExcelDownload = (tagTrendKeywordSectionType) => {
    const { getTagTrendKeywordAllListExcelDownload, tagTrendKeyword } = this.props;

    getTagTrendKeywordAllListExcelDownload({
      filterOption: tagTrendKeyword[tagTrendKeywordSectionType].itemList.filterOption,
      sortOption: tagTrendKeyword[tagTrendKeywordSectionType].itemList.sortOption,
    });
  };

  /**
   *  선택된 태그 리스트 엑셀 다운로드
   */
  getTagTrendKeywordSelectedListExcelDownload = (tagTrendKeywordSectionType) => {
    const { getTagTrendKeywordSelectedListExcelDownload, tagTrendKeyword } = this.props;
    const { idList } = tagTrendKeyword[tagTrendKeywordSectionType].selectedItemList;

    if (!idList.length) {
      message.error(NO_DATA_ON_EXCEL_DOWNLOAD_WARNING_TEXT);
      return;
    }

    getTagTrendKeywordSelectedListExcelDownload({
      tagIdList: idList,
    });
  };

  /**
   *  태그 엑셀 업로드
   */
  setTagTrendKeywordExcelUpload = (file, type) => {
    const { setTagTrendKeywordExcelUpload } = this.props;

    setTagTrendKeywordExcelUpload({
      attachment: [file],
      tagTrendKeywordSectionType: type,
    });
  };

  render() {
    const { tagTrendKeyword, getRelatedTagList } = this.props;

    return (
      <TagManagementTrendKeywordWrap
        tagTrendKeyword={tagTrendKeyword}
        getRelatedTagList={getRelatedTagList}
        onSubmit={this.onSubmit}
        getTagTrendKeywordContentsList={this.getTagTrendKeywordContentsList}
        selectTrendKeywordMainContentsList={this.selectTrendKeywordMainContentsList}
        onDragEndSelectTagTrendKeywordContentsList={this.onDragEndSelectTagTrendKeywordContentsList}
        tagTrendKeywordPreview={this.tagTrendKeywordPreview}
        getTagTrendKeywordAllListExcelDownload={this.getTagTrendKeywordAllListExcelDownload}
        getTagTrendKeywordSelectedListExcelDownload={this.getTagTrendKeywordSelectedListExcelDownload}
        setTagTrendKeywordExcelUpload={this.setTagTrendKeywordExcelUpload}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    tagTrendKeyword: state.tag.tagTrendKeyword,
  };
};

const mapDispatchToProps = {
  setData: tagActions.setData,
  getTagTrendKeywordData: tagActions.getTagTrendKeywordData,
  getTagTrendKeywordContentsList: tagActions.getTagTrendKeywordContentsList,
  getTagTrendKeywordPreviewData: tagActions.getTagTrendKeywordPreviewData,
  getTagTrendKeywordAllListExcelDownload: tagActions.getTagTrendKeywordAllListExcelDownload,
  getTagTrendKeywordSelectedListExcelDownload: tagActions.getTagTrendKeywordSelectedListExcelDownload,
  setTagTrendKeywordExcelUpload: tagActions.setTagTrendKeywordExcelUpload,
  toggleModal: tagActions.toggleModal,
  getRelatedTagList: appActions.getRelatedTagList,
};

export default connect(mapStateToProps, mapDispatchToProps)(TagTendKeywordManagementContainer);
